// src/pages/ArtStudio.js
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/ArtStudio.css';

function ArtStudio() {
  return (
    <motion.div
  className="artstudio-page"
  initial={{ opacity: 0, x: -30 }} // ✅ از سمت چپ وارد شود
  animate={{ opacity: 1, x: 0 }}   // ✅ به جایگاه اصلی برسد
  transition={{ duration: 0.9, ease: "easeOut" }}
>


      <h1>Dark Monad Art Studio</h1>
      <h2>Where Vision Meets Innovation</h2>

      <p>
        At the heart of Dark Monad’s immersive 3D animated art is a team of four highly skilled Native Canadian artists, 
        each bringing their expertise in motion design, 3D modeling, stage development, and advanced rendering techniques. 
        Their creative mastery ensures that every piece in the collection is crafted with precision, depth, and artistic excellence.
      </p>

      <h2>Our artists are responsible for:</h2>
      <ul>
        <li><strong>Motion Design</strong> – Bringing Dark Monad’s characters and environments to life with fluid and captivating animations.</li>
        <li><strong>3D Art & Modeling</strong> – Creating highly detailed models that embody the essence of Dark Monad’s vision.</li>
        <li><strong>Stage Development</strong> – Designing immersive settings that enhance the storytelling and aesthetic appeal of each piece.</li>
        <li><strong>Advanced Rendering</strong> – Utilizing cutting-edge technology to produce high-quality visuals with stunning details and dynamic effects.</li>
      </ul>

      <p>
        By merging traditional artistic techniques with modern digital tools, our art studio ensures that Dark Monad is not just an NFT collection—it is a cinematic 
        experience that redefines the standards of animated Web3 art.
      </p>

      <p>
        Through their dedication and innovation, our team is pushing the boundaries of blockchain-based digital art, 
        delivering a collection that is both visually breathtaking and technologically advanced.
      </p>

      <h2 className="tagline">Art. Motion. Innovation. Welcome to the world of Dark Monad.</h2>
    </motion.div>
  );
}

export default ArtStudio;
